import React, { useEffect, useState } from 'react'
import clsx from 'clsx';
// import Box from '@material-ui/core/Box'
// import Grid from '@material-ui/core/Grid'
import { Button, Icon, IconButton, InputAdornment, Popover, TextField, Checkbox, Box, Grid, CircularProgress } from '@mui/material'
// import { NavigateBefore, NavigateNext } from '@material-ui/icons'
import moment from 'moment'
import helper from '@utils/helper'
import filterIcon from '@assets/icons/tools/filter.svg'
import download_icon from '@assets/icons/download.svg'
import FileSaver from "file-saver";
import { NavigateBefore, NavigateNext } from '@mui/icons-material';
// import CircularProgress from "@material-ui/core/CircularProgress";
import styles from "./style.module.scss";
import { Search } from '@mui/icons-material';
import BasicDateRangePicker from '../DateRangePicker/DateRangePicker';
import useDebounce from '@components/common/Debounce/useDebounce';

const PopupToolbar = ({
    dateStartFilter,
    dateEndFilter,
    setDateStartFilter,
    setDateEndFilter,
    setStateFilter,
    anchorEl,
    setAnchorEl,
    inputValue,
    setInputValue,
    setPositionFilter,
    stateFilter,
    popupTypes = []
}) => {
    // const styles = useStyles();
    const [anchorFilterEl, setAnchorFilterEl] = React.useState(null);
    const limit = 20;
    const [page, setPage] = useState();
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handlePopoverFilterOpen = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorFilterEl(event.currentTarget);
    };
    
    const handlePopoverFilterClose = () => {
        setAnchorFilterEl(null);
    };
    const [valueDate, setValueDate] = useState([null, null])
    const cond = { page, limit };

    useEffect(() => {
     
        // if (valueDate[0]) {
        //     _.set(cond, 'startDate', new Date(valueDate[0]));
        //   }
        //   if (valueDate[1]) {
        //     _.set(cond, 'endDate', new Date(valueDate[1]));
        //   }
    }, [])

    const open = Boolean(anchorEl);
    const openFilter = Boolean(anchorFilterEl);
    // const stateFilter = {
    //     Headline: false,
    //     Center: false,
    //     Bottom: false
    // };

    const handleChange = (event) => {
        setStateFilter({
            ...stateFilter,
            [event.target.name]: event.target.checked,
        });
    };
    
    const handleFilter =()=>{
        let filter = []
        for(let i in stateFilter){
            if(stateFilter[i]) filter.push(i)
        }
        if(filter?.length>0) {
            setPositionFilter(filter.join(","))
        }
        if(filter?.length ===0){
            setPositionFilter('')
        }
        handlePopoverFilterClose()
    }

   useEffect(()=>{
    if(valueDate){
        setDateEndFilter(valueDate[1]);
        setDateStartFilter(valueDate[0]);
    }
   },[valueDate])
    return (
        <div className={styles.root}>
            <form id="search_box" style={{ width: '100%', padding:"0px 50px" }}>
                <Grid
                    container
                    alignItems='flex-end'
                    justifyContent='space-between'
                    className={styles.toolbarContainer}
                    spacing={2}
                >
                    <Box sx={{display:'flex', alignItems:'center'}} mb={1}>
                        <TextField
                            className={styles.searchBar}
                            placeholder='Tìm kiếm'
                            value={inputValue}
                            variant="standard"  
                            onChange={(e) => setInputValue(e.target.value)}
                            sx={{
                                '& .MuiInput-underline:before': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline:after    ': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#41B60B' },
                                '& .MuiInput-underline.Mui-focused:before': { borderBottomColor: '#41B60B' },
                              }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton className={styles.buttonSearch}>
                                            <Search className={styles.iconSearch}>search</Search>
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            name="email"
                        />  
                        <img onClick={handlePopoverFilterOpen} style={{width:"30px", cursor:'pointer'}} src={filterIcon} alt='filter-icon'/>
                    </Box>

                    <Box sx={{ display: 'flex'}}>
                        <BasicDateRangePicker valueDate={valueDate} setValueDate={setValueDate} disableFuture={false}/>
                    </Box>

                    <Popover
                        id="mouse-over-popover"
                        className={styles.popover}
                        styles={{
                        paper: styles.paper,
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                        }}
                        transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Box sx={{ width: '468px', padding: '32px'}}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                '& .MuiInputBase-root': {
                                    margin: '17px auto',
                                    width: '100%',
                                    fontSize: '14px'
                                }}}
                            >
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', '& button': {
                                margin: '0px 5px',
                                textTransform: 'none'
                            }}}>
                            </Box>
                        </Box>
                    </Popover>
                    
                    <Popover
                        id="mouse-over-popover"
                        className={styles.popover}
                        styles={{
                            paper: styles.paper,
                        }}
                        open={openFilter}
                        anchorEl={anchorFilterEl}
                        anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                        }}
                        transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                        }}
                        onClose={handlePopoverFilterClose}
                        disableRestoreFocus
                    >
                        <Box sx={{ width: '500px', padding: '32px'}}>
                            <Box sx={{ width: '100%', textAlign: 'left', fontSize: '18px', color: '#131313', mb: 3 }}>
                                Lọc theo loại popup
                            </Box>
                            <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                    gap: '10px 16px',
                                }}
                            >
                                {(popupTypes || []).map((type) => (
                                    <Box key={type._id || type.name} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Checkbox  sx={{color: "black",
                                                        '&.Mui-checked': {
                                                        color: "#41B60B",
                                                        },}} onChange={handleChange} checked={!!stateFilter?.[type.name]} name={type.name} ></Checkbox>
                                        <Box sx={{ ml: 1 }}>{type.label || type.name}</Box>
                                    </Box>
                                ))}
                                {(popupTypes || []).length === 0 && (
                                    <Box sx={{ color: '#777777' }}>Chưa có loại popup</Box>
                                )}
                            </Box>
                            <Box sx={{ display: 'flex', mt: 6, justifyContent: 'flex-end', '& button': {
                                margin: '0px 5px',
                                padding: '5px 45px',
                                textTransform: 'none'
                            }}}>
                                <Button onClick={handleFilter} variant='contained' style={{background:"#41B60B"}} size='large'>Lọc</Button>
                            </Box>
                        </Box>
                    </Popover>
                </Grid>
            </form>
        </div>
    )
}

PopupToolbar.propTypes = {}

PopupToolbar.defaultProps = {}

export default PopupToolbar;
